var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProfilePhoto52Placeholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-310.000000, -340.000000) translate(274.000000, 196.000000) translate(20.000000, 124.000000) translate(16.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D1",
    fillRule: "nonzero",
    d: "M21 11c-3.063 0-5.556 2.48-5.556 5.526 0 3.048 2.493 5.527 5.556 5.527s5.556-2.48 5.556-5.527S24.063 11 21 11zm0 8.842c-1.838 0-3.333-1.488-3.333-3.316 0-1.828 1.495-3.315 3.333-3.315s3.333 1.487 3.333 3.315c0 1.828-1.495 3.316-3.333 3.316zM31 32v-1.105c0-4.265-3.49-7.737-7.778-7.737h-4.444c-4.29 0-7.778 3.472-7.778 7.737V32h2.222v-1.105c0-3.047 2.492-5.527 5.556-5.527h4.444c3.064 0 5.556 2.48 5.556 5.527V32H31z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfilePhoto52Placeholder);
export default __webpack_public_path__ + "static/media/icon-profile-photo-52-placeholder.3811039939ccf6bec08fb49920c0252c.svg";
export { ForwardRef as ReactComponent };